import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { format, isValid } from "date-fns";

const ThemedDatePicker = ({
  label,
  value,
  onChange,
  theme,
  restrictFutureDates = true,
}) => {
  const maxDate = restrictFutureDates ? new Date() : undefined;

  return (
    <DatePicker
      label={label}
      value={value ? new Date(`${value}T00:00:00`) : null}
      maxDate={maxDate}
      format="yyyy-MM-dd"
      onChange={(date) => {
        const formatted = isValid(date)
          ? format(date, "yyyy-MM-dd")
          : "";

        onChange(formatted);
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          sx: {
            mt: 2,
            "& .MuiInputBase-root": {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
            "& input": {
              color: theme.palette.text.primary,
            },
          },
        },

        popper: {
          sx: {
            zIndex: 2000,
            "& .MuiPaper-root": {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              border: `1px solid ${theme.palette.divider}`,
              backgroundImage: "none",
            },
            "& .MuiPickersDay-root": {
              color: theme.palette.text.primary,
            },
            "& .Mui-selected": {
              backgroundColor:
                theme.palette.primary.main + " !important",
            },
          },
        },
      }}
    />
  );
};

export default ThemedDatePicker;